module.exports = __webpack_public_path__ + "static/media/python.334bc1fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/skills/backend/python.png
// module id = 1521
// module chunks = 0